import HBSelect from "../../HBInput/select";
/**
 * 分类下拉框
 * @param {*} props
 */
export default function CollectionsSelect({ collections, ...props }) {
  const filterOption = (value, option) => {
    return option.label?.includes(value);
  };
  return (
    <HBSelect
      {...props}
      placeholder="专辑"
      showSearch
      allowClear
      options={collections.map((item) => ({
        label: item.title,
        value: item.collection_id,
        ...item,
      }))}
      filterOption={filterOption}
    />
  );
}
